<template>
  <v-app>
    <AppBarAndNavigationDrawerSatisfactionResearch />

    <v-main class="app">
      <router-view />
    </v-main>

    <Footer />
  </v-app>
</template>

<script>
import AppBarAndNavigationDrawerSatisfactionResearch from '../components/AppBarAndNavigationDrawerSatisfactionResearch'
import Footer from '@/componentes/Footer'

export default {
  components: { AppBarAndNavigationDrawerSatisfactionResearch, Footer },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
